(function () {
  "use strict";

  if (window.__sahaelRealmIdentityInitialized) return;
  window.__sahaelRealmIdentityInitialized = true;

  var script = document.currentScript;
  if (!script) return;

  var manifestUrl = script.getAttribute("data-manifest-url");
  var assetBase = script.getAttribute("data-asset-base") || "";
  var assetVersion = script.getAttribute("data-asset-version") || "";

  function fail(message, error) {
    console.error("[SAHAEL realm identity] " + message, error || "");
  }

  function bloodlineId(element) {
    if (!element) return "";
    if (element.dataset.bloodlineId) return element.dataset.bloodlineId;
    if (element.dataset.bloodline) return element.dataset.bloodline;

    var testId = element.getAttribute("data-testid") || "";
    var match = testId.match(/^(?:link-bloodline-|bloodline-card-)(.+)$/);
    return match ? match[1] : "";
  }

  function assetUrl(assetName) {
    return assetBase + encodeURIComponent(assetName) + (assetVersion ? "?v=" + encodeURIComponent(assetVersion) : "");
  }

  function overlayChannels(color) {
    var hex = color.slice(1).match(/.{2}/g);
    if (!/^#[0-9a-f]{6}$/i.test(color) || !hex) {
      throw new Error("The realm manifest contains an invalid overlay color.");
    }
    return hex.map(function (channel) {
      return String(parseInt(channel, 16));
    }).join(" ");
  }

  function applyIdentity(element, identity, overlay) {
    if (!element || !identity) return;

    var background = assetUrl(identity.realmBackground.shopifyAsset);
    var overlayRgb = overlayChannels(overlay.color);
    var overlayGradient = "linear-gradient(rgb(" + overlayRgb + " / " + overlay.opacity + "), rgb(" + overlayRgb + " / " + overlay.opacity + "))";
    element.dataset.bloodlineId = identity.id;
    element.style.setProperty("--bloodline-accent", identity.signatureColor);
    element.style.setProperty("--bloodline-flame", identity.flameColor || identity.signatureColor);
    element.style.setProperty("--bloodline-heading-color", identity.signatureColor);
    element.style.setProperty("--bloodline-glow-color", identity.signatureColor);
    element.style.setProperty("--bloodline-body-color", "#e5e7eb");
    element.style.setProperty("--bloodline-realm-image", 'url("' + background + '")');
    element.style.setProperty("--bloodline-card-image", 'url("' + background + '")');
    element.style.setProperty("--bloodline-overlay-rgb", overlayRgb);
    element.style.setProperty("--bloodline-overlay-opacity", String(overlay.opacity));
    element.style.setProperty("--realm-glow", identity.signatureColor);
    element.style.setProperty("--bl-eye", identity.signatureColor);
    element.style.setProperty("--bl-border", "color-mix(in srgb, " + identity.signatureColor + " 46%, transparent)");
    element.style.setProperty("--bl-grad", overlayGradient);

    if (element.matches(".bloodline-identity-card")) {
      var cardName = element.querySelector("[data-bloodline-name]");
      if (cardName && cardName.textContent !== identity.displayName) {
        cardName.textContent = identity.displayName;
      }
    }

    if (element.matches("[data-sahael-bloodline-detail], .bl-detail")) {
      element.classList.add("sahael-bloodline-detail--realm");
      element.style.setProperty("--sahael-detail-realm-image", 'url("' + background + '")');
      var pageName = element.querySelector("[data-testid='bloodline-name']");
      if (pageName) {
        var pageTitle = pageName.dataset.bloodlineTitle || identity.displayName;
        if (pageName.textContent !== pageTitle) pageName.textContent = pageTitle;
      }
    }
  }

  function applyAll(manifest) {
    var identities = new Map(manifest.bloodlines.map(function (identity) {
      return [identity.id, identity];
    }));
    var elements = document.querySelectorAll(
      "[data-bloodline-id], [data-bloodline], [data-testid^='link-bloodline-'], [data-testid^='bloodline-card-']"
    );

    elements.forEach(function (element) {
      var id = bloodlineId(element);
      var identity = identities.get(id);
      if (!identity) {
        fail("No identity is registered for " + id + ".");
        return;
      }
      applyIdentity(element, identity, manifest.backgroundOverlay);
    });

    var detail = document.querySelector("[data-sahael-bloodline-detail], .bl-detail[data-bloodline]");
    var detailId = bloodlineId(detail);
    var detailIdentity = identities.get(detailId);
    if (detailIdentity) applyIdentity(detail, detailIdentity, manifest.backgroundOverlay);

    document.querySelectorAll("[role='dialog'], [data-testid='ability-modal']").forEach(function (dialog) {
      if (!detailIdentity) return;
      applyIdentity(dialog, detailIdentity, manifest.backgroundOverlay);
      dialog.classList.add("bloodline-identity-dialog");
    });
  }

  if (!manifestUrl) {
    fail("Manifest URL was not supplied by the theme.");
    return;
  }

  fetch(manifestUrl, { credentials: "same-origin" })
    .then(function (response) {
      if (!response.ok) throw new Error("Manifest request returned HTTP " + response.status);
      return response.json();
    })
    .then(function (manifest) {
      if (
        !manifest ||
        manifest.schemaVersion !== 1 ||
        !Array.isArray(manifest.bloodlines) ||
        !manifest.backgroundOverlay ||
        !/^#[0-9a-f]{6}$/i.test(manifest.backgroundOverlay.color || "") ||
        !Number.isFinite(manifest.backgroundOverlay.opacity) ||
        manifest.backgroundOverlay.opacity < 0 ||
        manifest.backgroundOverlay.opacity > 1
      ) {
        throw new Error("The realm manifest has an unsupported shape.");
      }
      applyAll(manifest);

      var observer = new MutationObserver(function () {
        applyAll(manifest);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    })
    .catch(function (error) {
      fail("Could not apply the generated realm manifest.", error);
    });
})();
